<template>
  <!-- Ścieżka w tym samym układzie co w module zamówień: Home › Menu zamówień › … -->
  <nav class="hidden h-8 md:flex" aria-label="Breadcrumb">
    <ol role="list" class="flex space-x-4 rounded-md bg-white px-6 shadow">
      <li class="flex">
        <div class="flex items-center">
          <router-link to="/hub" class="transition ease-in-out duration-300 text-gray-400 hover:text-gray-500">
            <HomeIcon class="h-5 w-5 flex-shrink-0" aria-hidden="true" />
            <span class="sr-only">Home</span>
          </router-link>
        </div>
      </li>
      <li v-for="item in items" :key="item.label" class="flex">
        <div class="flex items-center">
          <svg class="h-full w-6 flex-shrink-0 text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" aria-hidden="true">
            <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
          </svg>
          <router-link v-if="item.to" :to="item.to" class="transition ease-in-out duration-300 ml-4 text-xs font-medium text-gray-500 hover:text-gray-700">{{ item.label }}</router-link>
          <div v-else class="ml-4 max-w-xs truncate text-xs font-medium text-gray-400 cursor-default" aria-current="page">{{ item.label }}</div>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
import { HomeIcon } from '@heroicons/vue/solid';

export default {
  name: 'SubiektBreadcrumb',
  components: { HomeIcon },
  props: {
    // Ostatni element bez linku - bieżąca strona.
    current: { type: String, required: true },
    // Czy pokazać „Dokumenty do Subiekta" jako krok pośredni (podstrony panelu).
    inPanel: { type: Boolean, default: false },
  },
  computed: {
    items() {
      const items = [{ label: 'Menu zamówień', to: '/dashboard/orders' }];
      if (this.inPanel) items.push({ label: 'Dokumenty do Subiekta', to: '/dashboard/subiekt/dokumenty' });
      items.push({ label: this.current });
      return items;
    },
  },
};
</script>
